import type { PublicUser } from '@shared/schemas.js';

export type AdminRouteDecision = 'render' | 'redirect';

/**
 * Client-side UX gate for administrative pages.
 *
 * The server remains the security boundary. This exists so a VA who manually
 * types an admin URL never sees a half-rendered page whose API calls then 403.
 * While authentication is disabled, LeadForge preserves its legacy local-only
 * behavior and renders every route.
 */
export function adminRouteGate(input: {
  authEnabled: boolean;
  user: PublicUser | null;
}): AdminRouteDecision {
  if (!input.authEnabled) return 'render';
  return input.user?.role === 'admin' ? 'render' : 'redirect';
}
